import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';
import { Observable, of } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import keycloak from '../keycloak-init';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private permissionsService: PermissionsService,
    private snackBar: MatSnackBar
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> {

    // Verificar autenticación con Keycloak
    if (!keycloak.authenticated) {
      // Si no está autenticado, Keycloak redirigirá automáticamente al login
      keycloak.login();
      return false;
    }

    // Si hay un ID de menú en la ruta, verificar permisos
    const menuId = route.data['id'] as number;
    if (menuId) {
      // Obtener sessionId del token de Keycloak o del localStorage como fallback
      const sessionId = keycloak.tokenParsed?.['sessionId']
        ? parseInt(keycloak.tokenParsed['sessionId'] as string)
        : parseInt(localStorage.getItem('sessionId') || '0');

      if (sessionId === 0) {
        this.snackBar.open('No se pudo verificar tu sesión', 'Cerrar', {
          duration: 3000,
          panelClass: ['warning-snackbar']
        });
        return false;
      }

      return this.permissionsService.getMenusRutaModulos(sessionId, menuId);
    }

    return true;
  }
}
